export default __webpack_public_path__ + "static/media/instagramDeskFill.f94916eb.svg";